import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import Button from 'components/DesignSystem/Button';
import useDatedImageDownload from 'hooks/useDatedImageDownload';
import useMJOStatus from 'hooks/Meteorology/Weather/Area/Status/MJO/useMJOStatus';
import CentralizedSpinner from 'components/CentralizedSpinner';
import EnlargeableImage from 'components/Meteorology/Fields/SynopticCharts/SynopticChart/Map/EnlargeableImage';
import Selector from 'components/DesignSystem/Selector';
import useIsMobile from 'utils/hooks/useIsMobile';
import StatusCard from 'components/Meteorology/Weather/Area/Status/Mobile/StatusCard';

export default function DiagramPanel({ models }: { models: string[] }) {
  const isMobile = useIsMobile();
  const [model, setModel] = useState('');
  const { statusImageBase64, statusImageLoading } = useMJOStatus(model);
  const {
    onDownloadClick,
    downloadDisabled,
  } = useDatedImageDownload(statusImageBase64, statusImageLoading, `mjo_status_${model}`);

  const modelSelector = (
    <Selector
      id="modelSelect"
      placeholder="Modelo"
      value={model}
      setValue={setModel}
      containerClassName="flex-grow-1 me-2"
    >
      {models.map((option) => (
        <option key={option} value={option}>{option}</option>
      ))}
    </Selector>
  );

  const downloadButton = (
    <Button
      id="diagramImageDownloadButton"
      small
      className="icon-button weather-download-button"
      onClick={onDownloadClick}
      disabled={downloadDisabled}
      icon="download"
    />
  );

  if (isMobile) {
    return (
      <StatusCard title="DIAGRAMA DE FASES">
        <div className="status-controls-mobile">
          {modelSelector}
          {downloadButton}
        </div>
        {statusImageLoading && <CentralizedSpinner />}
        {statusImageBase64 && (
          <EnlargeableImage src={`data:image/png;base64,${statusImageBase64}`} className="mt-3" />
        )}
      </StatusCard>
    );
  }

  return (
    <Card className="shadow-sm forecast-instruction-card h-100">
      <Card.Header>
        DIAGRAMA DE FASES
      </Card.Header>
      <Card.Body>
        <div className="d-flex justify-content-between mt-3 align-items-center">
          {modelSelector}
          {downloadButton}
        </div>
        {statusImageLoading && <CentralizedSpinner />}
        <EnlargeableImage src={`data:image/png;base64,${statusImageBase64}`} className="mt-3" />
      </Card.Body>
    </Card>
  );
}
